module.exports = __webpack_public_path__ + "static/media/query.a6dcc3fe.png";